import { render, staticRenderFns } from "./corporateOutstanding.vue?vue&type=template&id=198c1f9d&"
import script from "./corporateOutstanding.vue?vue&type=script&lang=js&"
export * from "./corporateOutstanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports